import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  timeout: 60000,
  headers: { 'Content-Type': 'application/json' },
});

export const postContact = (payload) => apiClient.post('/contact', payload).then(r => r.data);
export const postNewsletter = (payload) => apiClient.post('/newsletter', payload).then(r => r.data);
export const postChat = (payload) => apiClient.post('/chat', payload).then(r => r.data);
export const getChatHistory = (sessionId) => apiClient.get(`/chat/history/${sessionId}`).then(r => r.data);
export const getBlog = (language) => apiClient.get(`/blog?language=${language}`).then(r => r.data);
export const getBlogPost = (slug, language) => apiClient.get(`/blog/${slug}?language=${language}`).then(r => r.data);
export const postBooking = (payload) => apiClient.post('/bookings', payload).then(r => r.data);
export const getBookingAvailability = (date) => apiClient.get(`/bookings/availability?date=${date}`).then(r => r.data);
export const getGeo = () => apiClient.get('/geo').then(r => r.data);

// Admin
export const adminLogin = (password) => apiClient.post('/admin/login', { password }).then(r => r.data);
const adminAuth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
export const adminMe = (token) => apiClient.get('/admin/me', adminAuth(token)).then(r => r.data);
export const adminGetStats = (token) => apiClient.get('/admin/stats', adminAuth(token)).then(r => r.data);
export const adminGetContacts = (token) => apiClient.get('/admin/contacts', adminAuth(token)).then(r => r.data);
export const adminGetNewsletter = (token) => apiClient.get('/admin/newsletter', adminAuth(token)).then(r => r.data);
export const adminGetBookings = (token) => apiClient.get('/admin/bookings', adminAuth(token)).then(r => r.data);
export const adminGetChats = (token) => apiClient.get('/admin/chats', adminAuth(token)).then(r => r.data);
export const adminGetChatDetail = (token, sid) => apiClient.get(`/admin/chats/${sid}`, adminAuth(token)).then(r => r.data);
